var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurBenefit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_18884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 1.42871H10.0001C5.26627 1.42871 1.42871 5.26627 1.42871 10.0001V30.0001C1.42871 34.734 5.26627 38.5716 10.0001 38.5716H30.0001C34.734 38.5716 38.5716 34.734 38.5716 30.0001V10.0001C38.5716 5.26627 34.734 1.42871 30.0001 1.42871Z",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14258 20.0572H12.8569L17.1426 12.8857L21.4283 28.6L27.1426 20.0572H32.8569",
    stroke: "#00CC61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_18884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurBenefit3);
export default __webpack_public_path__ + "static/media/icon-our-benefit-3.bd017f6dd97400d9af298816f25fe910.svg";
export { ForwardRef as ReactComponent };